import axios from "axios";
import { shopifyUploadURL } from "utils/constants";

const shopifyFileUpload = async (inputs) => {
    try {
        // delete keys with non-file values
        Object.keys(inputs).forEach((key) => {
            if (!inputs[key] || inputs[key].constructor !== File) {
                delete inputs[key];
            }
        });

        const shopifyFiles = await Promise.all(
            Object.entries(inputs).map(async (input) => {
                const [fieldName, file] = input;
                if (file) {
                    const response = await axios.post(shopifyUploadURL, { file }, { headers: { "Content-Type": "multipart/form-data" } });
                    return { [fieldName]: response?.data?.url ? response.data.url : "" };
                }
                return null;
            }),
        );

        return shopifyFiles.reduce((obj, prop) => ({ ...obj, ...(prop !== null && prop) }), {});
    } catch (error) {
        return null;
    }
};

export default shopifyFileUpload;
